export default __webpack_public_path__ + "static/media/banner5.80e130ab.svg";